// Миксин для склонения префикса к возрасту

export default {
  data() {
    return {
      titles: [
        this.$t('common.year'),
        this.$t('common.of_year'),
        this.$t('common.years')
      ]
    }
  },
  methods: {
    getAgePrefix(n) {
      const cases = [2, 0, 1, 1, 1, 2]
      // eslint-disable-next-line
      return this.titles[
        n % 100 > 4 && n % 100 < 20 ? 2 : cases[n % 10 < 5 ? n % 10 : 5]
      ]
    }
  }
}
